// Основное состояние для возвратов
export interface RefundState {
  isLoading: {
    list: boolean;
    create: boolean;
    retrieve: boolean;
    uploadAttachments: boolean;
  };
  errors: {
    list: string | null;
    create: string | null;
    retrieve: string | null;
    uploadAttachments: string | null;
  };
  list: RefundDTO[] | null;
  uploadId: string | null;
  current: RefundDTO | null;
}

export const RefundStatus = {
  NEW: 0,
  IN_PROGRESS: 1,
  APPROVED: 2,
  REJECTED: 3,
};

// DTO для возврата
export interface RefundDTO {
  status: number;
  number: number;
  reason: string;
  pk: string;
  is_active: boolean;
  created_at: string;
  order_item: OrderItemDTO;
  attachments: AttachmentDTO[];
  user_id: string;
}

// DTO для элемента заказа (Order Item)
export interface OrderItemDTO {
  good_name: string;
  good_description: string;
  comment: string;
  amount: number;
  price: string;
  delivery_term: number;
  pk: string;
  is_active: boolean;
  order_id: string;
}

// DTO для вложения (Attachment)
export interface AttachmentDTO {
  file: string;
  pk: string;
  is_active: boolean;
}

// Константы для экшенов

// Получение списка возвратов
export const GET_REFUNDS_REQUEST = 'GET_REFUNDS_REQUEST';
export const GET_REFUNDS_SUCCESS = 'GET_REFUNDS_SUCCESS';
export const GET_REFUNDS_FAILURE = 'GET_REFUNDS_FAILURE';

// Создание возврата
export const CREATE_REFUND_REQUEST = 'CREATE_REFUND_REQUEST';
export const CREATE_REFUND_SUCCESS = 'CREATE_REFUND_SUCCESS';
export const CREATE_REFUND_FAILURE = 'CREATE_REFUND_FAILURE';

// Получение конкретного возврата
export const RETRIEVE_REFUND_REQUEST = 'RETRIEVE_REFUND_REQUEST';
export const RETRIEVE_REFUND_SUCCESS = 'RETRIEVE_REFUND_SUCCESS';
export const RETRIEVE_REFUND_FAILURE = 'RETRIEVE_REFUND_FAILURE';

// Загрузка вложений
export const UPLOAD_ATTACHMENTS_REQUEST = 'UPLOAD_ATTACHMENTS_REQUEST';
export const UPLOAD_ATTACHMENTS_SUCCESS = 'UPLOAD_ATTACHMENTS_SUCCESS';
export const UPLOAD_ATTACHMENTS_FAILURE = 'UPLOAD_ATTACHMENTS_FAILURE';
